var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pta-admin" }, [
    _c("h1", { staticStyle: { "margin-bottom": "5px" } }, [
      _vm._v("Pipeline\n      "),
      _c(
        "button",
        {
          staticClass: "btn btn-info btn-sm m-l-20",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.showDeals.apply(null, arguments)
            },
          },
        },
        [
          _c("i", { staticClass: "icon-14" }),
          _vm._v(" "),
          _c("span", { staticClass: "d-sm-inline" }, [_vm._v("Manage Deals")]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("h3", { staticStyle: { "margin-bottom": "60px" } }, [
      _vm._v(_vm._s(_vm.company) + " "),
      _c(
        "a",
        {
          attrs: {
            href: "/account/users/general-partners/" + _vm.id,
            target: "_blank",
          },
        },
        [_c("i", { staticClass: "fas fa-circle-info" })]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "pta-pipeline-status" }, [
      _c("ul", [
        _c("li", [
          _c("span", [_vm._v(_vm._s(_vm.investors_number))]),
          _vm._v("Active Deals"),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("span", [
            _vm._v("$" + _vm._s(_vm._f("formatAmount")(_vm.investors_amount))),
          ]),
          _vm._v("Average Deal Value"),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("span", [_vm._v(_vm._s(_vm.investors_completed))]),
          _vm._v("Number of "),
          _c("br"),
          _vm._v("meetings completed"),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "pta-pipeline-sort" }, [
      _c("ul", [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "li",
          {
            class:
              _vm.filterInvestorForm.sort_by == "created_at"
                ? _vm.filterInvestorForm.order == "asc"
                  ? "active-asc"
                  : "active-desc"
                : "",
            on: {
              click: function ($event) {
                $event.preventDefault()
                _vm.filterInvestorForm.sort_by = "created_at"
                  ? _vm.filterInvestorForm.order == "desc"
                    ? (_vm.filterInvestorForm.order = "asc")
                    : (_vm.filterInvestorForm.order = "desc")
                  : (_vm.filterInvestorForm.order = "asc")
                _vm.filterInvestorForm.sort_by = "created_at"
              },
            },
          },
          [_c("span", [_vm._v("Date created")])]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class:
              _vm.filterInvestorForm.sort_by == "name"
                ? _vm.filterInvestorForm.order == "asc"
                  ? "active-asc"
                  : "active-desc"
                : "",
            on: {
              click: function ($event) {
                $event.preventDefault()
                _vm.filterInvestorForm.sort_by = "name"
                  ? _vm.filterInvestorForm.order == "desc"
                    ? (_vm.filterInvestorForm.order = "asc")
                    : (_vm.filterInvestorForm.order = "desc")
                  : (_vm.filterInvestorForm.order = "asc")
                _vm.filterInvestorForm.sort_by = "name"
              },
            },
          },
          [_c("span", [_vm._v("Name")])]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class:
              _vm.filterInvestorForm.sort_by == "amount"
                ? _vm.filterInvestorForm.order == "asc"
                  ? "active-asc"
                  : "active-desc"
                : "",
            on: {
              click: function ($event) {
                $event.preventDefault()
                _vm.filterInvestorForm.sort_by = "amount"
                  ? _vm.filterInvestorForm.order == "desc"
                    ? (_vm.filterInvestorForm.order = "asc")
                    : (_vm.filterInvestorForm.order = "desc")
                  : (_vm.filterInvestorForm.order = "asc")
                _vm.filterInvestorForm.sort_by = "amount"
              },
            },
          },
          [_c("span", [_vm._v("Value")])]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class:
              _vm.filterInvestorForm.sort_by == "closed_at"
                ? _vm.filterInvestorForm.order == "asc"
                  ? "active-asc"
                  : "active-desc"
                : "",
            on: {
              click: function ($event) {
                $event.preventDefault()
                _vm.filterInvestorForm.sort_by = "closed_at"
                  ? _vm.filterInvestorForm.order == "desc"
                    ? (_vm.filterInvestorForm.order = "asc")
                    : (_vm.filterInvestorForm.order = "desc")
                  : (_vm.filterInvestorForm.order = "asc")
                _vm.filterInvestorForm.sort_by = "closed_at"
              },
            },
          },
          [_c("span", [_vm._v("Close date")])]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class:
              _vm.filterInvestorForm.sort_by == "updated_at"
                ? _vm.filterInvestorForm.order == "asc"
                  ? "active-asc"
                  : "active-desc"
                : "",
            on: {
              click: function ($event) {
                $event.preventDefault()
                _vm.filterInvestorForm.sort_by = "updated_at"
                  ? _vm.filterInvestorForm.order == "desc"
                    ? (_vm.filterInvestorForm.order = "asc")
                    : (_vm.filterInvestorForm.order = "desc")
                  : (_vm.filterInvestorForm.order = "asc")
                _vm.filterInvestorForm.sort_by = "updated_at"
              },
            },
          },
          [_c("span", [_vm._v("Last updates")])]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class:
              _vm.filterInvestorForm.sort_by == "pd_stage_id"
                ? _vm.filterInvestorForm.order == "asc"
                  ? "active-asc"
                  : "active-desc"
                : "",
            on: {
              click: function ($event) {
                $event.preventDefault()
                _vm.filterInvestorForm.sort_by = "pd_stage_id"
                  ? _vm.filterInvestorForm.order == "desc"
                    ? (_vm.filterInvestorForm.order = "asc")
                    : (_vm.filterInvestorForm.order = "desc")
                  : (_vm.filterInvestorForm.order = "asc")
                _vm.filterInvestorForm.sort_by = "pd_stage_id"
              },
            },
          },
          [_c("span", [_vm._v("Deal Stage")])]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pta-pipeline-campaigns" },
      _vm._l(_vm.investors.data, function (investor) {
        return _c("div", { staticClass: "pta-pipeline-campaign" }, [
          _c("div", { staticClass: "pta-pipeline-campaign-left" }, [
            _c("h3", [
              _vm._v(_vm._s(investor.name) + " "),
              _c(
                "a",
                {
                  attrs: {
                    href: "/account/investors/" + investor.investor_id,
                    target: "_blank",
                  },
                },
                [_c("i", { staticClass: "fas fa-circle-info" })]
              ),
              _vm._v(" "),
              investor.completed_at
                ? _c(
                    "span",
                    {
                      staticStyle: {
                        "font-weight": "400",
                        display: "inline-block",
                        "font-size": "14px",
                      },
                    },
                    [_vm._v("(Campaign is completed)")]
                  )
                : investor.stopped_at
                ? _c(
                    "span",
                    {
                      staticStyle: {
                        "font-weight": "400",
                        display: "inline-block",
                        "font-size": "14px",
                      },
                    },
                    [_vm._v("(Campaign is stopped)")]
                  )
                : investor.paused_at
                ? _c(
                    "span",
                    {
                      staticStyle: {
                        "font-weight": "400",
                        display: "inline-block",
                        "font-size": "14px",
                      },
                    },
                    [_vm._v("(Campaign is paused)")]
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pta-pipeline-campaign-left" }, [
            _c(
              "ul",
              {
                staticClass: "pta-pipeline-statusline pta-pipeline-size-13",
                class:
                  _vm.show_index == investor.id
                    ? "pta-pipeline-show-labels pta-pipeline-color-" +
                      investor.color_id
                    : "pta-pipeline-color-" + investor.color_id,
                attrs: { "data-id": "inv-stage-" + investor.pd_stage_id },
              },
              _vm._l(_vm.pipeline_stages, function (pipeline_stage, index) {
                return _c(
                  "li",
                  {
                    class: _vm.isActiveStage(index, investor.pd_stage_id),
                    attrs: { "data-id": "stage-" + pipeline_stage.pd_stage_id },
                  },
                  [
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(pipeline_stage.name))]),
                    ]),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("i", {
              staticClass: "pta-pipeline-icon-show",
              class:
                _vm.show_index == investor.id ? "pta-pipeline-icon-hide" : "",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.show_index == investor.id
                    ? (_vm.show_index = 0)
                    : (_vm.show_index = investor.id)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pta-pipeline-campaign-right" }, [
            _c("span", { staticClass: "pta-pipeline-amount" }, [
              _vm._v("$" + _vm._s(_vm._f("formatAmount")(investor.amount))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "pta-pipeline-date" }, [
              _vm._v(_vm._s(_vm._f("momentDate")(investor.updated_at))),
            ]),
          ]),
          _vm._v(" "),
          investor.type == "auto"
            ? _c("div", { staticClass: "pta-pipeline-action-buttons" }, [
                _c("ul", [
                  !investor.stopped_at &&
                  !investor.paused_at &&
                  !investor.completed_at
                    ? _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "confirm",
                              rawName: "v-confirm",
                              value: { ok: _vm.confirmPause(investor) },
                              expression: "{ok: confirmPause(investor)}",
                            },
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Pause campaign",
                              expression: "'Pause campaign'",
                            },
                          ],
                        },
                        [
                          _c("i", { staticClass: "fas fa-pause" }),
                          _vm._v(" Pause campaign"),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !investor.stopped_at &&
                  investor.paused_at &&
                  !investor.completed_at
                    ? _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "confirm",
                              rawName: "v-confirm",
                              value: { ok: _vm.confirmResume(investor) },
                              expression: "{ok: confirmResume(investor)}",
                            },
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Resume campaign",
                              expression: "'Resume campaign'",
                            },
                          ],
                        },
                        [
                          _c("i", { staticClass: "fas fa-play" }),
                          _vm._v(" Resume campaign"),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !investor.stopped_at && !investor.completed_at
                    ? _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "confirm",
                              rawName: "v-confirm",
                              value: { ok: _vm.confirmStop(investor) },
                              expression: "{ok: confirmStop(investor)}",
                            },
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Stop campaign",
                              expression: "'Stop campaign'",
                            },
                          ],
                        },
                        [
                          _c("i", { staticClass: "fas fa-stop" }),
                          _vm._v(" Stop campaign"),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !investor.completed_at
                    ? _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: investor.transcripts.length
                                ? "Complete campaign"
                                : "No transcript found.",
                              expression:
                                "investor.transcripts.length?'Complete campaign':'No transcript found.'",
                            },
                            {
                              name: "confirm",
                              rawName: "v-confirm",
                              value: { ok: _vm.confirmComplete(investor) },
                              expression: "{ok: confirmComplete(investor)}",
                            },
                          ],
                          class: !investor.transcripts.length
                            ? "pta-disable"
                            : "",
                        },
                        [
                          _c("i", { staticClass: "fas fa-circle-check" }),
                          _vm._v(" Complete campaign"),
                        ]
                      )
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pta-pipeline-buttons",
              staticStyle: { "margin-top": "-46px" },
            },
            [
              investor.investor
                ? _c(
                    "a",
                    {
                      staticClass: "pta-pipeline-button",
                      attrs: {
                        href:
                          "https://proptecham.ai/account/investors/" +
                          investor.investor.id +
                          "/profile/" +
                          _vm.id,
                      },
                    },
                    [_vm._v("View Profile")]
                  )
                : _vm._e(),
              _vm._v(" "),
              investor.investor && investor.investor.website
                ? _c(
                    "a",
                    {
                      staticClass: "pta-pipeline-button",
                      attrs: {
                        href: investor.investor.website.startsWith("http")
                          ? investor.investor.website.split(",")[0].trim()
                          : "https://" +
                            investor.investor.website.split(",")[0].trim(),
                        target: "_blank",
                      },
                    },
                    [_vm._v("View website")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "pta-pipeline-button",
                  class: investor.investor ? "" : "pta-pipeline-button-disable",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      investor.investor
                        ? _vm.showNotes(investor.id, investor.investor_notes)
                        : false
                    },
                  },
                },
                [_vm._v("Notes")]
              ),
              _vm._v(" "),
              investor.investor
                ? _c(
                    "a",
                    {
                      staticClass: "pta-pipeline-button",
                      attrs: {
                        href:
                          "https://proptecham.ai/account/investors/" +
                          investor.investor.id +
                          "/notes",
                        target: "_blank",
                      },
                    },
                    [_vm._v("Internal Notes")]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm.selected_notes_index == investor.id
            ? _c("div", { staticClass: "pta-pipeline-campaign-details" }, [
                _c("div", { staticClass: "row" }, [
                  investor.investor_notes && investor.investor_notes.length
                    ? _c("div", { staticClass: "col-12 col-sm-12" }, [
                        _c("h4", [
                          _vm._v(
                            _vm._s(investor.investor_notes.length) +
                              " notes found. "
                          ),
                          !_vm.showNoteCreatePanel
                            ? _c("i", {
                                staticClass: "fas fa-plus-circle",
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function ($event) {
                                    _vm.showNoteCreatePanel =
                                      !_vm.showNoteCreatePanel
                                  },
                                },
                              })
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _c("table", { staticClass: "table table-hover" }, [
                            _c(
                              "tbody",
                              _vm._l(investor.investor_notes, function (note) {
                                return note.user_investor_id ==
                                  _vm.selected_notes_index
                                  ? _c("tr", [
                                      !note.pd_id
                                        ? _c("td", [
                                            note.creator_user
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "block",
                                                      "margin-bottom": "5px",
                                                      "font-size": "12px",
                                                      "line-height": "18px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "created by " +
                                                        _vm._s(
                                                          note.creator_user
                                                            .profile.first_name
                                                        ) +
                                                        " on " +
                                                        _vm._s(
                                                          _vm._f("moment")(
                                                            note.created_at
                                                          )
                                                        )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !note.creator_user
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "block",
                                                      "margin-bottom": "5px",
                                                      "font-size": "12px",
                                                      "line-height": "18px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "created by " +
                                                        _vm._s(
                                                          note.creator_user_name
                                                        ) +
                                                        " on " +
                                                        _vm._s(
                                                          _vm._f("moment")(
                                                            note.created_at
                                                          )
                                                        )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(note.text) +
                                                "\n                    "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      note.pd_id
                                        ? _c("td", [
                                            note.creator_user
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "block",
                                                      "margin-bottom": "5px",
                                                      "font-size": "12px",
                                                      "line-height": "18px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "created by " +
                                                        _vm._s(
                                                          note.creator_user
                                                            .profile.first_name
                                                        ) +
                                                        " on " +
                                                        _vm._s(
                                                          _vm._f("moment")(
                                                            note.created_at
                                                          )
                                                        )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !note.creator_user
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "block",
                                                      "margin-bottom": "5px",
                                                      "font-size": "12px",
                                                      "line-height": "18px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "created by " +
                                                        _vm._s(
                                                          note.creator_user_name
                                                        ) +
                                                        " on " +
                                                        _vm._s(
                                                          _vm._f("moment")(
                                                            note.created_at
                                                          )
                                                        )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(note.text),
                                              },
                                            }),
                                          ])
                                        : _vm._e(),
                                    ])
                                  : _vm._e()
                              }),
                              0
                            ),
                          ]),
                        ]),
                      ])
                    : !_vm.showNoteCreatePanel
                    ? _c("div", { staticClass: "col-12 col-sm-12" }, [
                        _c("h4", [
                          _vm._v("No notes available. "),
                          !_vm.showNoteCreatePanel
                            ? _c("i", {
                                staticClass: "fas fa-plus-circle",
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function ($event) {
                                    _vm.showNoteCreatePanel =
                                      !_vm.showNoteCreatePanel
                                  },
                                },
                              })
                            : _vm._e(),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showNoteCreatePanel &&
                  _vm.selected_notes_index == investor.id
                    ? _c("div", { staticClass: "col-12 col-sm-12" }, [
                        _c(
                          "form",
                          {
                            attrs: { autocomplete: "off" },
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.submitInvestorNote(
                                  investor.investor_id
                                )
                              },
                              keydown: function ($event) {
                                return _vm.investorNoteForm.errors.clear(
                                  $event.target.name
                                )
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-12" }, [
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticStyle: {
                                              "font-size": "16px",
                                            },
                                            attrs: { for: "" },
                                          },
                                          [_vm._v("New note")]
                                        ),
                                        _vm._v(" "),
                                        _c("autosize-textarea", {
                                          attrs: {
                                            placeholder: "",
                                            rows: "2",
                                            name: "text",
                                          },
                                          model: {
                                            value: _vm.investorNoteForm.text,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.investorNoteForm,
                                                "text",
                                                $$v
                                              )
                                            },
                                            expression: "investorNoteForm.text",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("show-error", {
                                          attrs: {
                                            "form-name": _vm.investorNoteForm,
                                            "prop-name": "text",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-info waves-effect waves-light pull-right",
                                attrs: { type: "submit" },
                              },
                              [_vm._v(_vm._s(_vm.trans("general.add")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-danger waves-effect waves-light pull-right m-r-10",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    _vm.showNoteCreatePanel =
                                      !_vm.showNoteCreatePanel
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.trans("general.cancel")))]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.selected_index == investor.id
            ? _c("div", { staticClass: "pta-pipeline-campaign-details" }, [
                _c("div", { staticClass: "row" }, [
                  investor.investor_contact
                    ? _c("div", { staticClass: "col-12 col-sm-12" }, [
                        _vm._v(
                          "\n                Contact person: " +
                            _vm._s(investor.investor_contact.first_name) +
                            " " +
                            _vm._s(investor.investor_contact.last_name)
                        ),
                        _c("br"),
                        _vm._v("\n                Contact email: "),
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "mailto:" +
                                investor.investor_contact.email_work,
                            },
                          },
                          [_vm._v(_vm._s(investor.investor_contact.email_work))]
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                Contact phone: " +
                            _vm._s(
                              investor.investor_contact.phone_work
                                ? investor.investor_contact.phone_work
                                : ""
                            ) +
                            "\n              "
                        ),
                      ])
                    : _c("div", { staticClass: "col-12 col-sm-12" }, [
                        _vm._v(
                          "\n                No contact found.\n              "
                        ),
                      ]),
                ]),
                _vm._v(" "),
                investor.description
                  ? _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 col-sm-12" }, [
                        _vm._v("\n                Description:"),
                        _c("br"),
                        _vm._v(
                          "\n                " +
                            _vm._s(investor.description) +
                            "\n              "
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.selected_history_index == investor.id
            ? _c("div", { staticClass: "pta-pipeline-campaign-details" }, [
                _c("h4", { staticClass: "card-title" }, [_vm._v("History")]),
                _vm._v(" "),
                _vm.emails_pipeline
                  ? _c(
                      "div",
                      { staticClass: "pta-timeline" },
                      _vm._l(
                        _vm.emails_pipeline,
                        function (emails_pipeline_entry) {
                          return _c(
                            "div",
                            {
                              staticClass: "pta-timeline-container",
                              class:
                                "pta-timeline-" + emails_pipeline_entry.type,
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function ($event) {
                                  return _vm.showEmail(emails_pipeline_entry)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "pta-timeline-content" },
                                [
                                  _c("h2", [
                                    _vm._v(
                                      _vm._s(emails_pipeline_entry.subject)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  emails_pipeline_entry.subject != "Note"
                                    ? _c(
                                        "p",
                                        {
                                          staticStyle: { "margin-bottom": "0" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(emails_pipeline_entry.info)
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            _vm._s(emails_pipeline_entry.from)
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            _vm._s(emails_pipeline_entry.to)
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  emails_pipeline_entry.subject == "Note"
                                    ? _c(
                                        "p",
                                        {
                                          staticStyle: { "margin-bottom": "0" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(emails_pipeline_entry.info)
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            _vm._s(emails_pipeline_entry.from)
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            _vm._s(emails_pipeline_entry.to)
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            _vm._s(emails_pipeline_entry.body)
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    )
                  : _c("div", [
                      _vm._v(
                        "\n            No history information available yet.\n"
                      ),
                    ]),
              ])
            : _vm._e(),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "modal fade", attrs: { id: "modalDeals" } }, [
      _c(
        "div",
        { staticClass: "modal-dialog", staticStyle: { "max-width": "920px" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "modal-body",
                staticStyle: { "font-size": "18px", "line-height": "24px" },
                attrs: { id: "modalBody" },
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm-12 pta-content-quest" },
                    [
                      _c("h4", { staticClass: "card-title" }, [
                        _vm._v(" "),
                        !_vm.showCreatePanel && _vm.has_uploads
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-info btn-sm pull-right m-r-10",
                                on: {
                                  click: function ($event) {
                                    _vm.showCreatePanel = !_vm.showCreatePanel
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "fas fa-plus" }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "d-none d-sm-inline" },
                                  [_vm._v("Add Investor")]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("transition", { attrs: { name: "fade" } }, [
                        _vm.showCreatePanel
                          ? _c("div", { staticClass: "card border-bottom" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "card-body p-4",
                                  staticStyle: { background: "#efefef" },
                                },
                                [
                                  _c(
                                    "form",
                                    {
                                      attrs: { autocomplete: "off" },
                                      on: {
                                        submit: function ($event) {
                                          $event.preventDefault()
                                          return _vm.submit.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                        keydown: function ($event) {
                                          return _vm.userInvestorForm.errors.clear(
                                            $event.target.name
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-12 col-sm-12" },
                                          [
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                { staticClass: "col-12" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "form-group",
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        { attrs: { for: "" } },
                                                        [_vm._v("Investors")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("v-select", {
                                                        attrs: {
                                                          label: "name",
                                                          "track-by": "id",
                                                          name: "investor_id",
                                                          id: "investor_id",
                                                          options:
                                                            _vm.investors_search
                                                              .data,
                                                          placeholder:
                                                            "Enter investor name to search ...",
                                                          multiple: false,
                                                          "close-on-select": true,
                                                          "clear-on-select": false,
                                                          showNoOptions: false,
                                                          "hide-selected": true,
                                                          placeholder:
                                                            "Enter investor name to search ...",
                                                          selectLabel: "choose",
                                                        },
                                                        on: {
                                                          "search-change": (
                                                            val
                                                          ) =>
                                                            _vm.searchInvestor(
                                                              val
                                                            ),
                                                        },
                                                        model: {
                                                          value: _vm.investor,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.investor = $$v
                                                          },
                                                          expression:
                                                            "investor",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("show-error", {
                                                        attrs: {
                                                          "form-name":
                                                            _vm.userInvestorForm,
                                                          "prop-name":
                                                            "investor_id",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-info waves-effect waves-light pull-right",
                                          attrs: { type: "submit" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.trans("general.add"))
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-danger waves-effect waves-light pull-right m-r-10",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              _vm.showCreatePanel =
                                                !_vm.showCreatePanel
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.trans("general.cancel"))
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _vm.user_investors.total
                        ? _c("div", { staticClass: "card" }, [
                            _c(
                              "div",
                              {
                                staticClass: "card-body",
                                staticStyle: { padding: "0" },
                              },
                              [
                                _vm.hasPermission("list-user") &&
                                _vm.user_investors.total
                                  ? _c(
                                      "div",
                                      { staticClass: "table-responsive" },
                                      [
                                        _c(
                                          "table",
                                          { staticClass: "table table-hover" },
                                          [
                                            _c("thead", [
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.trans(
                                                          "investor.name"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Value")]
                                                ),
                                                _vm._v(" "),
                                                _c("th", {
                                                  staticClass: "table-option",
                                                  attrs: { scope: "col" },
                                                }),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "tbody",
                                              _vm._l(
                                                _vm.user_investors.data,
                                                function (investor) {
                                                  return _c("tr", [
                                                    _c("td", {
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          investor.name
                                                        ),
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      [
                                                        _vm.editIndex ==
                                                        investor.id
                                                          ? _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .editInvestor
                                                                      .amount,
                                                                  expression:
                                                                    "editInvestor.amount",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              attrs: {
                                                                value: "",
                                                                name:
                                                                  "amount_" +
                                                                  investor.id,
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .editInvestor
                                                                    .amount,
                                                              },
                                                              on: {
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    )
                                                                      return
                                                                    _vm.$set(
                                                                      _vm.editInvestor,
                                                                      "amount",
                                                                      $event
                                                                        .target
                                                                        .value
                                                                    )
                                                                  },
                                                              },
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.editIndex ==
                                                        investor.id
                                                          ? _c("show-error", {
                                                              attrs: {
                                                                "form-name":
                                                                  _vm.editInvestorForm,
                                                                "prop-name":
                                                                  "amount",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.editIndex !=
                                                        investor.id
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  investor.amount
                                                                )
                                                              ),
                                                            ])
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "table-option",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "btn-group",
                                                          },
                                                          [
                                                            _vm.editIndex ==
                                                            investor.id
                                                              ? _c(
                                                                  "button",
                                                                  {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "tooltip",
                                                                          rawName:
                                                                            "v-tooltip",
                                                                          value:
                                                                            "Save value",
                                                                          expression:
                                                                            "'Save value'",
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "btn btn-info btn-sm",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.updateInvestor(
                                                                            investor
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-save",
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _vm.editIndex !=
                                                            investor.id
                                                              ? _c(
                                                                  "button",
                                                                  {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "tooltip",
                                                                          rawName:
                                                                            "v-tooltip",
                                                                          value:
                                                                            "Edit value",
                                                                          expression:
                                                                            "'Edit value'",
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "btn btn-info btn-sm",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.startEdit(
                                                                            investor
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-pencil-alt",
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _vm.hasPermission(
                                                              "delete-user"
                                                            )
                                                              ? _c(
                                                                  "button",
                                                                  {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "confirm",
                                                                          rawName:
                                                                            "v-confirm",
                                                                          value:
                                                                            {
                                                                              ok: _vm.confirmDelete(
                                                                                investor
                                                                              ),
                                                                            },
                                                                          expression:
                                                                            "{ok: confirmDelete(investor)}",
                                                                        },
                                                                        {
                                                                          name: "tooltip",
                                                                          rawName:
                                                                            "v-tooltip",
                                                                          value:
                                                                            "Remove investor",
                                                                          expression:
                                                                            "'Remove investor'",
                                                                        },
                                                                      ],
                                                                    key: investor.id,
                                                                    staticClass:
                                                                      "btn btn-danger btn-sm",
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-trash",
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ])
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ])
                        : !_vm.has_uploads
                        ? _c("div", [
                            _vm._v(
                              "The user must upload a fact sheet, presentation and their team bios first!"
                            ),
                          ])
                        : _c("div", [_vm._v("No investors assigned.")]),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("span", [_vm._v("Lost Deals")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "modal-header", staticStyle: { display: "block" } },
      [
        _c(
          "button",
          {
            staticClass: "close",
            attrs: { type: "button", "data-dismiss": "modal" },
          },
          [
            _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")]),
            _vm._v(" "),
            _c("span", { staticClass: "sr-only" }, [_vm._v("close")]),
          ]
        ),
        _vm._v(" "),
        _c("h4", { staticClass: "modal-title", attrs: { id: "modalTitle" } }, [
          _vm._v("Deals"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }